import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export interface ISetupStepConfig {
  /** Step number (1, 2, 3) */
  stepNumber: number;
  /** Title of the step */
  title: string;
  /** Description of what happens in this step */
  description: string;
}

export function useMetaSetupSteps(): ISetupStepConfig[] {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        stepNumber: 1,
        title: t('Authorize Connection'),
        description: t("You'll be redirected to Meta to sign in and grant permissions"),
      },
      {
        stepNumber: 2,
        title: t('Select Your Assets'),
        description: t('Choose which business accounts and pages to connect'),
      },
      {
        stepNumber: 3,
        title: t('Start Advertising'),
        description: t('Create and manage Pixl Plus campaigns that target Meta'),
      },
    ],
    [t],
  );
}
